import { catalogAdminClient } from '@/lib/api/ts-rest';

/** Catalog image upload — multipart over the ts-rest contract (admin-only). */
export async function uploadCatalogImage(
  file: File,
  category: string,
): Promise<string> {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('category', category);

  const res = await catalogAdminClient.uploadCatalogImage({ body: formData });
  if (res.status !== 201) {
    throw new Error('Upload failed');
  }
  return res.body.imageUrl;
}
